// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__270DS","link":"Navigation_link__1gOvq","activeLink":"Navigation_activeLink__Mp-Pq"};